import * as i18nApp from 'vue-i18n';

import messages from './';

const i18n = i18nApp.createI18n({
    legacy: false, // you must set `false`, to use Composition API
    locale: 'ja', // set locale
    fallbackLocale: 'en', // set fallback locale
    messages, // set locale messages
    // If you need to specify other options, you can set other options
    // ...
  })


export default i18n;